import React from "react";
import Select from "react-select";
import CustomStyles from "./CustomStyles";

const ResizableSelect = props => {
  return <Select {...props} styles={CustomStyles} />;
};

export default ResizableSelect;
